import React, { useState, useEffect } from "react";

// import UploadUtil
import UploadUtil from "../Util/uploadUtil";

// import react date picker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// react country and state
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

// import react hot toast
import toast, { Toaster } from "react-hot-toast";

// react router dom
import { Link, useHistory } from "react-router-dom";

// import registerValidation
import {
  tokenRegistrationValidation,
  registerValidation,
} from "../Util/Validations";

// paystack payment module
import { usePaystackPayment } from "react-paystack";

// Footer
import Footer from "../Components/Footer";

// import axios
import axios from "../Util/axiosConfig";

// import react Helmet
import { Helmet, HelmetProvider } from "react-helmet-async";

// CertificateUpload import
import CertificateUpload from "../Util/CertificateUpload";

// import date of birth helper
import { toDobString } from "../Util/dateUtils";

// init config for paystack payment
const config = {
  reference: new Date().getTime(),
  email: (process.env.REACT_APP_PAYSTACK_EMAIL || "").trim(),
  amount: 305000, // Amount in kobo (3050 NGN)
  publicKey: (process.env.REACT_APP_PAYSTACK_PUBLIC_KEY || "").trim(),
};

// init Register Page
const RegisterWithToken = (props) => {
  // get confirmationToken
  const confirmationToken = props.match.params.token;

  // init useHistory
  const history = useHistory();

  // init dateOfBirth
  const [dateofBirth, setDateOfBirth] = useState(new Date());

  // init Loading state
  const [Loading, setLoading] = useState(false);

  // init registration state
  const [registrationData, setRegistrationData] = useState({
    firstName: "",
    surname: "",
    otherName: "",
    email: "",
    confirmEmail: "",
    phone: "",
    profile_pic: "",
    sex: "",
    lga: "",
    postal_address: "",
    password: "",
    confirmPassword: "",
    accessToken: "",
  });

  // init certificate state
  const [certificateUrl, setCertificateUrl] = useState("");

  // init country state
  const [country, setCountry] = useState("");

  // init state_of_origin
  const [state_of_origin, setStateOfOrigin] = useState("");

  // init qualificationData state
  const [qualificationData, setQualificationData] = useState([
    {
      qualification: "",
      universityAttended: "",
      yearofEntry: "",
      yearofGraduation: "",
      regNumber: "",
    },
  ]);

  // init payment mode state
  const [paymentMode, setPaymentMode] = useState(""); // "card" or "token"

  // destructure registrationData
  const {
    firstName,
    surname,
    otherName,
    email,
    confirmEmail,
    phone,
    profile_pic,
    sex,
    lga,
    postal_address,
    password,
    confirmPassword,
    accessToken,
  } = registrationData;

  // init handleChange
  const handleChange = (data) => (e) => {
    // update registration Data
    setRegistrationData({ ...registrationData, [data]: e.target.value });
  };

  // certificate upload handler
  const handleCertificateUpload = (url) => {
    setCertificateUrl(url);
    setRegistrationData({
      ...registrationData,
      nursingCertificate: url,
    });
  };

  // init handleAddInputField
  const handleAddInputFields = () => {
    // spread the values in state
    const stateValues = [...qualificationData];

    // push an empty object in array
    stateValues.push({
      qualification: "",
      universityAttended: "",
      yearofEntry: "",
      yearofGraduation: "",
      regNumber: "",
    });

    // assign to the state
    setQualificationData(stateValues);
  };

  // handle Remove Input Fields
  const handleRemoveInputFields = (index) => {
    // spread the values in state
    const stateValues = [...qualificationData];

    // remove the index value from array
    stateValues.splice(index, 1);

    // assign to the state
    setQualificationData(stateValues);
  };

  // init handleQualificationChange
  const handleQualificationChange = (event, index, field) => {
    // spread qualificationData
    const stateValues = [...qualificationData];

    // get index and field
    stateValues[index][field] = event.target.value;

    // update qualification Data
    setQualificationData(stateValues);
  };

  // ===================== PAYMENT SECTION =================================
  // Update paystack config with user email
  const updatedConfig = {
    ...config,
    email: email || config.email,
  };

  // init payment onSuccess
  const onSuccess = (reference) => {
    console.log("Payment successful:", reference);
    // Proceed with registration after successful payment
    handleDirectRegistration();
  };

  // init payment onClose function
  const onClose = () => {
    console.log("Payment modal closed");
    toast.error("Payment was not completed");
  };

  // initialize payment
  const initializePayment = usePaystackPayment(updatedConfig);

  // Handle direct registration after payment
  const handleDirectRegistration = () => {
    // update loading to true
    setLoading(true);

    // get RegisterData
    const registerData = {
      firstName: firstName,
      surname: surname,
      otherName: otherName,
      email: email,
      phone: phone,
      profile_pic: profile_pic,
      sex: sex,
      dob: toDobString(dateofBirth),
      country: country,
      state_of_origin: state_of_origin,
      lga: lga,
      address: postal_address,
      password: password,
      qualifications: qualificationData,
      nursingCertificate: certificateUrl,
      WPkh_paid_DXJ: true, // Mark as paid
    };

    // validate using registerValidation (not tokenRegistrationValidation)
    const error = registerValidation(registerData);

    // check if error
    if (error) {
      // update loading to false
      setLoading(false);
      return toast.error(error);
    }

    // post request to register endpoint
    axios
      .post("/v1/api/user/register", registerData)
      .then(({ data }) => {
        // update loading to false
        setLoading(false);

        // check if not successful
        if (!data.success) {
          return toast.error(data.data);
        }

        // success toast
        toast.success(data.data);

        // redirect to login page
        return history.push("/login");
      })
      .catch((error) => {
        // update loading to false
        setLoading(false);
        console.log(error);
        return toast.error("Oops! An error has occurred");
      });
  };

  // =======================END PAYMENT SECTION======================================================

  // init handleSubmit function
  const handleSubmit = () => {
    // update loading to true
    setLoading(true);

    // get RegisterData
    const registerData = {
      firstName: firstName,
      surname: surname,
      otherName: otherName,
      email: email,
      confirmEmail: confirmEmail,
      phone: phone,
      profile_pic: profile_pic,
      sex: sex,
      country: country,
      state_of_origin: state_of_origin,
      lga: lga,
      address: postal_address,
      password: password,
      confirmPassword: confirmPassword,
      accessToken: accessToken,
      dob: toDobString(dateofBirth),
      qualifications: qualificationData,
      nursingCertificate: certificateUrl,
    };

    // validate registerData
    const error = tokenRegistrationValidation(registerData);

    // check if error
    if (error) {
      // update loading to false
      setLoading(false);

      return toast.error(error);
    }

    // axios request to token register endpoint
    axios
      .post("/v1/api/access/token/register", registerData)
      .then(({ data }) => {
        // update Loading
        setLoading(false);

        // check if not success
        if (!data.success) {
          return toast.error(data.data);
        }

        // redirect to login
        history.push({ pathname: "/login", state: { message: data.data } });
      })
      .catch((error) => {
        // update Loading
        setLoading(false);

        console.log(error);
      });
  };

  return (
    <React.Fragment>
      <HelmetProvider>
        <Toaster />

        <Helmet>
          <title>Registration Portal - Ugonsa</title>
        </Helmet>

        <div className="page-container" style={{ backgroundColor: "#efefef" }}>
          <div className="page-breadcrumb">
            <div className="row">
              <div className="col"></div>
              <div className="col-sm-5 col-md-5 align-self-center mb-3">
                <Link to="/">
                  <img
                    width="150"
                    height="150"
                    alt="ugonsa-logo"
                    className="img-fluid"
                    style={{ margin: "auto", display: "block" }}
                    src="/assets/images/ugonsa_logo.png"
                  />
                </Link>

                <h2 className="page-title text-center">Registration Portal</h2>
                <h5 className="text-center mt-4">
                  Choose your preferred payment method
                </h5>
                <div className="text-center mt-2">
                  <p>
                    <strong>Option 1:</strong> Pay with Card (₦3,050) - Instant
                    Registration
                  </p>
                  <p>
                    <strong>Option 2:</strong> Pay via Transfer & Use Access
                    Token
                  </p>
                </div>
              </div>
              <div className="col"></div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row pr-3 pl-3">
              <div className="col-lg-4 col-xlg-3 col-md-5">
                {/* About Access token registration */}
                <div className="card rounded shadow-sm bg-white">
                  <div className="card-body">
                    <h4 className="page-title p-2">
                      <b>About Access Token Registration (ATR)</b>
                    </h4>

                    <p className="mt-3 p-2">
                      Access Token Registration (ATR) is an alternative
                      registration process provided by UGONSA to enable you
                      create your account without online payment.
                    </p>

                    <p className="p-2">
                      <b>Steps to register with access token</b>
                    </p>

                    <ul className="p-2">
                      <li className="p-2">
                        Make payments (Registration Fee: &#8358;3,050) to UGONSA
                        bank account: <b>3089525712</b>, Bank: <b>FirstBank</b>
                      </li>
                      <li className="p-2">
                        Send proof of payment via email to{" "}
                        <b>info@ugonsa.org</b> or <b>gnan2ugonsa@gmail.com</b>
                      </li>
                      <li className="p-2">
                        Wait for 24 hours to recieve your access token
                      </li>
                      <li className="p-2">
                        Enter your access token in the "Access Token" field to
                        create your account.
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Image and Cert Upload */}
                <div className="card rounded shadow-sm bg-white">
                  <div className="card-body">
                    <center className="m-t-30">
                      <UploadUtil
                        uploadImageUrl={(image_url) =>
                          setRegistrationData({
                            ...registrationData,
                            profile_pic: image_url,
                          })
                        }
                      />

                      <p>Note: Passport photograph must be less than 300kb</p>
                    </center>
                  </div>

                  <div className="form-group">
                    <label className="col-md-12">Upload Certificate</label>
                    <div className="col-md-12">
                      <CertificateUpload
                        uploadCertificateUrl={handleCertificateUpload}
                      />
                      <small>
                        Upload your nursing degree certificate (PDF, DOC or
                        Image)
                      </small>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>

              <div className="col-lg-8 col-xlg-9 col-md-7">
                <div className="card rounded shadow-sm bg-white">
                  <div className="card-body">
                    <form className="form-horizontal form-material">
                      <div className="row">
                        <div className="col-md-4">
                          {/* Surname */}
                          <div className="form-group">
                            <label className="col-md-12">Surname</label>
                            <div className="col-md-12">
                              <input
                                type="text"
                                placeholder="Enter Surname"
                                value={surname}
                                onChange={handleChange("surname")}
                                className="form-control form-control-line"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          {/* First Name */}
                          <div className="form-group">
                            <label className="col-md-12">First Name</label>
                            <div className="col-md-12">
                              <input
                                type="text"
                                placeholder="Enter First Name"
                                value={firstName}
                                onChange={handleChange("firstName")}
                                className="form-control form-control-line"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          {/* Other Name */}
                          <div className="form-group">
                            <label className="col-md-12">
                              Other Name (if any)
                            </label>
                            <div className="col-md-12">
                              <input
                                type="text"
                                placeholder="Enter Other Name"
                                value={otherName}
                                onChange={handleChange("otherName")}
                                className="form-control form-control-line"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          {/* Email */}
                          <div className="form-group">
                            <label htmlFor="email" className="col-md-12">
                              Email
                            </label>
                            <div className="col-md-12">
                              <input
                                type="email"
                                placeholder="e-mail address"
                                value={email}
                                onChange={handleChange("email")}
                                className="form-control form-control-line"
                              />
                              <small>
                                Please provide a valid email to enable you
                                recieve informations.
                              </small>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          {/* Confirm Email */}
                          <div className="form-group">
                            <label htmlFor="email" className="col-md-12">
                              Confirm Email
                            </label>
                            <div className="col-md-12">
                              <input
                                type="email"
                                placeholder="confirm e-mail address"
                                value={confirmEmail}
                                onChange={handleChange("confirmEmail")}
                                className="form-control form-control-line"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          {/* date of birth */}
                          <div className="form-group">
                            <label htmlFor="dob" className="col-md-12">
                              Date of Birth
                            </label>
                            <div className="col-md-12">
                              <DatePicker
                                className="form-control form-control-line"
                                selected={dateofBirth}
                                onChange={(date) => setDateOfBirth(date)}
                                dateFormat="dd/MM/yyyy"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Phone */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="phone" className="col-md-12">
                              Phone Number
                            </label>
                            <div className="col-md-12">
                              <input
                                type="number"
                                placeholder="Enter Phone Number"
                                value={phone}
                                onChange={handleChange("phone")}
                                className="form-control form-control-line"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Sex */}
                      <div className="form-group">
                        <label className="col-sm-12">Gender</label>
                        <div className="col-sm-12">
                          <select
                            onChange={handleChange("sex")}
                            className="form-control form-control-line"
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          {/* Country*/}
                          <div className="form-group">
                            <label className="col-sm-12">Country</label>
                            <div className="col-sm-12">
                              <CountryDropdown
                                classes="form-control form-control-line"
                                value={country}
                                onChange={(val) => setCountry(val)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {/* State */}
                          <div className="form-group">
                            <label className="col-sm-12">State/Region</label>
                            <div className="col-sm-12">
                              <RegionDropdown
                                classes="form-control form-control-line"
                                country={country}
                                value={state_of_origin}
                                onChange={(val) => setStateOfOrigin(val)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* LGA */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="lga" className="col-md-12">
                              Local Government Area or County
                            </label>
                            <div className="col-md-12">
                              <input
                                type="text"
                                placeholder="Enter Local Government Area (LGA) or County"
                                value={lga}
                                onChange={handleChange("lga")}
                                className="form-control form-control-line"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Postal Address */}
                      <div className="form-group">
                        <label htmlFor="address" className="col-md-12">
                          Permanent Address
                        </label>
                        <div className="col-md-12">
                          <textarea
                            type="text"
                            value={postal_address}
                            onChange={handleChange("postal_address")}
                            placeholder="Enter Permanent Address"
                            className="form-control form-control-line"
                          ></textarea>
                        </div>
                      </div>

                      <hr />

                      {/* Qualification */}
                      {qualificationData.map((formData, index) => {
                        return (
                          <div className="mt-3" key={index}>
                            {/* Qualification */}
                            <div className="form-group">
                              <label className="col-sm-12">Qualification</label>
                              <div className="col-sm-12">
                                <select
                                  onChange={(event) =>
                                    handleQualificationChange(
                                      event,
                                      index,
                                      "qualification"
                                    )
                                  }
                                  className="form-control form-control-line"
                                >
                                  <option value="">Select Qualification</option>
                                  <option value="B.N.Sc/B.S.N/B.Sc Nursing">
                                    B.N.Sc/B.S.N/B.Sc Nursing
                                  </option>
                                  <option value="M.Sc">M.Sc</option>
                                  <option value="Ph.D">Ph.D</option>
                                </select>
                              </div>
                            </div>

                            {/* University Attended */}
                            <div className="form-group">
                              <label
                                htmlFor="university_attended"
                                className="col-md-12"
                              >
                                University Attended
                              </label>
                              <div className="col-md-12">
                                <input
                                  value={formData.universityAttended}
                                  onChange={(event) =>
                                    handleQualificationChange(
                                      event,
                                      index,
                                      "universityAttended"
                                    )
                                  }
                                  type="text"
                                  placeholder="Enter University"
                                  className="form-control form-control-line"
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                {/* Year of Entry */}
                                <div className="form-group">
                                  <label
                                    htmlFor="year_of_entry"
                                    className="col-md-12"
                                  >
                                    Year of Entry
                                  </label>
                                  <div className="col-md-12">
                                    <input
                                      value={formData.yearofEntry}
                                      onChange={(event) =>
                                        handleQualificationChange(
                                          event,
                                          index,
                                          "yearofEntry"
                                        )
                                      }
                                      type="number"
                                      placeholder="Enter Year of Entry"
                                      className="form-control form-control-line"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                {/* Year of Graduation */}
                                <div className="form-group">
                                  <label
                                    htmlFor="year_of_graduation"
                                    className="col-md-12"
                                  >
                                    Year of Graduation
                                  </label>
                                  <div className="col-md-12">
                                    <input
                                      value={formData.yearofGraduation}
                                      onChange={(event) =>
                                        handleQualificationChange(
                                          event,
                                          index,
                                          "yearofGraduation"
                                        )
                                      }
                                      type="number"
                                      placeholder="Enter Year of Graduation"
                                      className="form-control form-control-line"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-6">
                                {/* Registration Number */}
                                <div className="form-group">
                                  <label
                                    htmlFor="registration_number"
                                    className="col-md-12"
                                  >
                                    University Matriculation Number
                                  </label>
                                  <div className="col-md-12">
                                    <input
                                      value={formData.regNumber}
                                      onChange={(event) =>
                                        handleQualificationChange(
                                          event,
                                          index,
                                          "regNumber"
                                        )
                                      }
                                      type="text"
                                      placeholder="Enter University Matriculation Number"
                                      className="form-control form-control-line"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <button
                                  type="button"
                                  onClick={() => handleRemoveInputFields(index)}
                                  className="btn btn-danger mt-4"
                                >
                                  <i
                                    className="fa fa-trash"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <button
                        type="button"
                        onClick={() => handleAddInputFields()}
                        className="btn btn-secondary mb-5 mt-3"
                      >
                        + Add Qualification
                      </button>

                      <hr />

                      <div className="row">
                        {/* password */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="col-md-6">Password</label>
                            <div className="col-md-12">
                              <input
                                type="password"
                                value={password}
                                onChange={handleChange("password")}
                                placeholder="password"
                                className="form-control form-control-line"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Confirm Password */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="col-md-6">Confirm Password</label>
                            <div className="col-md-12">
                              <input
                                type="password"
                                value={confirmPassword}
                                onChange={handleChange("confirmPassword")}
                                placeholder="confirm password"
                                className="form-control form-control-line"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Payment Mode Selection */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="col-md-12">
                              <strong>Choose Payment Method</strong>
                            </label>
                            <div className="col-md-12">
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  type="radio"
                                  id="payWithCard"
                                  name="paymentMode"
                                  className="custom-control-input"
                                  value="card"
                                  checked={paymentMode === "card"}
                                  onChange={(e) =>
                                    setPaymentMode(e.target.value)
                                  }
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="payWithCard"
                                >
                                  <strong>
                                    Pay with Card (Instant Registration)
                                  </strong>
                                </label>
                              </div>
                              <small className="text-muted d-block mb-2">
                                Pay ₦3,050 instantly with your card and get
                                registered immediately
                              </small>

                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  type="radio"
                                  id="payWithToken"
                                  name="paymentMode"
                                  className="custom-control-input"
                                  value="token"
                                  checked={paymentMode === "token"}
                                  onChange={(e) =>
                                    setPaymentMode(e.target.value)
                                  }
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="payWithToken"
                                >
                                  <strong>
                                    Pay via Transfer & Use Access Token
                                  </strong>
                                </label>
                              </div>
                              <small className="text-muted d-block">
                                Pay via bank transfer and use the access token
                                provided to you
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Access Token - Only show when token payment is selected */}
                      {paymentMode === "token" && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="col-md-6">Access Token</label>
                              <div className="col-md-12">
                                <input
                                  type="text"
                                  value={accessToken}
                                  onChange={handleChange("accessToken")}
                                  placeholder="Enter your access token"
                                  className="form-control form-control-line"
                                />
                                <small>
                                  Provide the valid access token you received
                                  after payment confirmation
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Button */}
                      <div className="form-group">
                        <div className="col-sm-12">
                          {!Loading ? (
                            <>
                              {paymentMode === "card" && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    // Validate form before payment
                                    const registerData = {
                                      firstName,
                                      surname,
                                      otherName,
                                      email,
                                      phone,
                                      profile_pic,
                                      sex,
                                      country,
                                      state_of_origin,
                                      lga,
                                      password,
                                      address: postal_address,
                                      qualifications: qualificationData,
                                      nursingCertificate: certificateUrl,
                                      dob: toDobString(dateofBirth),
                                    };

                                    const error =
                                      registerValidation(registerData);
                                    if (error) {
                                      return toast.error(error);
                                    }

                                    // Initialize payment
                                    initializePayment(onSuccess, onClose);
                                  }}
                                  className="btn btn-success mt-3"
                                >
                                  <i className="fa fa-credit-card"></i> Pay
                                  ₦3,050 & Register
                                </button>
                              )}

                              {paymentMode === "token" && (
                                <button
                                  type="button"
                                  onClick={() => handleSubmit()}
                                  className="btn btn-primary mt-3"
                                >
                                  <i className="fa fa-key"></i> Register with
                                  Token
                                </button>
                              )}

                              {!paymentMode && (
                                <button
                                  type="button"
                                  className="btn btn-secondary mt-3"
                                  disabled
                                >
                                  Please select a payment method
                                </button>
                              )}
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-success mt-3"
                              disabled
                            >
                              <i className="fa fa-spinner fa-spin"></i>{" "}
                              Processing...
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                  <p className="text-center">
                    Need help with payment?
                    <Link to="/create/account"> Create Account First</Link>
                  </p>

                  <p className="text-center">
                    Already have an account?
                    <Link to="/login"> Login</Link>
                  </p>

                  <div className="alert alert-info mt-3">
                    <small>
                      <strong>Payment Options:</strong>
                      <br />• <strong>Card Payment:</strong> Pay ₦3,050
                      instantly and get registered immediately
                      <br />• <strong>Transfer Payment:</strong> Pay via bank
                      transfer and use the access token provided
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </HelmetProvider>
    </React.Fragment>
  );
};

export default RegisterWithToken;
